(function() { window.GUID_975c486d_58f3_4436_97fe_8e5ebcfed25c = { getGuid: function() { return "975c486d-58f3-4436-97fe-8e5ebcfed25c"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let LegalDocument;
        (function (LegalDocument) {
            LegalDocument[LegalDocument["PrivacyPolicy"] = 0] = "PrivacyPolicy";
            LegalDocument[LegalDocument["TermsOfServices"] = 1] = "TermsOfServices";
            LegalDocument[LegalDocument["SubscriptionTermsAndConditions"] = 2] = "SubscriptionTermsAndConditions";
            LegalDocument[LegalDocument["TermsOfUse"] = 3] = "TermsOfUse";
        })(LegalDocument = Enumeration.LegalDocument || (Enumeration.LegalDocument = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=LegalDocument.pre.js.map
